import React from "react";
import { COLORS, FONT_SIZES, STROKES } from "../hooks/useToolPanel";
import "../styles/tool-panel.css";
export default function ToolPanel({ toolPanel, config = {
    color: false,
    stroke: false,
    fontSize: false
} }) {
    return (React.createElement("div", { className: "tool-panel" },
        config.color && (React.createElement("div", { className: "section" },
            React.createElement("div", { className: "section-title" }, "Color"),
            React.createElement("div", { className: "color-options" }, Object.values(COLORS).map((color) => {
                const isSelected = color === toolPanel.color.value;
                return (React.createElement("button", { key: color, className: ['color-box', isSelected && 'active'].filter(Boolean).join(' '), style: { background: color }, onClick: () => toolPanel.color.set(color), title: color }));
            })))),
        config.stroke && (React.createElement("div", { className: "section" },
            React.createElement("div", { className: "section-title" }, "Grosor"),
            React.createElement("div", { className: "stroke-options" }, Object.entries(STROKES).map(([stroke, value]) => {
                const isSelected = value === toolPanel.stroke.value;
                return (React.createElement("button", { key: stroke, className: ['stroke-button', isSelected && 'active'].filter(Boolean).join(' '), onClick: () => toolPanel.stroke.set(value), title: `Grosor ${stroke}` },
                    React.createElement("div", { className: `stroke-line ${stroke.toLowerCase()}` })));
            })))),
        config.fontSize && (React.createElement("div", { className: "section" },
            React.createElement("div", { className: "section-title" }, "Texto"),
            React.createElement("div", { className: "text-options" }, Object.values(FONT_SIZES).map((value) => {
                const isSelected = value === toolPanel.fontSize.value;
                const char = (() => {
                    if (value === 30)
                        return "S";
                    else if (value === 50)
                        return "M";
                    else
                        return "L";
                })();
                return (React.createElement("button", { key: value, className: ['font-size-button', isSelected && 'active'].filter(Boolean).join(' '), onClick: () => toolPanel.fontSize.set(value), title: `Tamaño ${char}` }, char));
            }))))));
}
